import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useState, useEffect } from 'react';

const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://kiyafet-magazasi-backend.vercel.app';

type Kampanya = {
  id: number;
  baslik: string;
  aciklama?: string;
  resim: string;
  link?: string;
  aktif?: boolean;
  sira?: number;
};

export function HeroSection() {
  const [kampanyalar, setKampanyalar] = useState<Kampanya[]>([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    fetch(`${API_URL}/api/kampanyalar`)
      .then(r => r.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        const aktif = data
          .filter((k: Kampanya) => k.aktif !== false && k.resim)
          .sort((a: Kampanya, b: Kampanya) => (a.sira || 0) - (b.sira || 0));
        setKampanyalar(aktif);
        setCurrentSlide(0);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (kampanyalar.length <= 1) return;
    const timer = setInterval(() => setCurrentSlide(p => (p + 1) % kampanyalar.length), 7000);
    return () => clearInterval(timer);
  }, [kampanyalar.length]);

  const next = () => setCurrentSlide(p => (p + 1) % Math.max(kampanyalar.length, 1));
  const prev = () => setCurrentSlide(p => (p - 1 + kampanyalar.length) % Math.max(kampanyalar.length, 1));

  const handleClick = (kampanya: Kampanya) => {
    const link = kampanya.link || '';
    if (link.includes('Kimono') || link.toLowerCase().includes('kimono')) {
      const catButtons = document.querySelectorAll('button');
      catButtons.forEach(btn => {
        if (btn.textContent?.trim() === 'Kimono') btn.click();
      });
      setTimeout(() => {
        document.getElementById('products-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
      return;
    }
    if (link.startsWith('http')) {
      window.location.href = link;
      return;
    }
    document.getElementById('products-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  if (kampanyalar.length === 0) {
    return (
      <div className="w-full bg-[#f5f0e8] flex items-center justify-center py-16">
        <p className="text-gray-500">Kampanya yükleniyor...</p>
      </div>
    );
  }

  const kampanya = kampanyalar[currentSlide] || kampanyalar[0];

  return (
    <div className="relative w-full bg-[#f5f0e8]">
      <button
        type="button"
        onClick={() => handleClick(kampanya)}
        className="block w-full cursor-pointer focus:outline-none"
        aria-label={kampanya.baslik}
      >
        {/* Orijinal ebat: kırpma yok, tam görünür */}
        <img
          src={kampanya.resim}
          alt={kampanya.baslik}
          className="w-full h-auto block"
          style={{ width: '100%', height: 'auto', objectFit: 'contain', display: 'block' }}
        />
      </button>

      {kampanyalar.length > 1 && (
        <>
          <button
            type="button"
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 z-20 bg-white/90 hover:bg-white rounded-full p-3 shadow"
            aria-label="Önceki kampanya"
          >
            <ChevronLeft className="size-6 text-gray-900" />
          </button>
          <button
            type="button"
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 z-20 bg-white/90 hover:bg-white rounded-full p-3 shadow"
            aria-label="Sonraki kampanya"
          >
            <ChevronRight className="size-6 text-gray-900" />
          </button>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
            {kampanyalar.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setCurrentSlide(i)}
                className={`h-2.5 rounded-full transition-all border-0 cursor-pointer ${i === currentSlide ? 'w-10 bg-white' : 'w-2.5 bg-white/60'}`}
                aria-label={`Kampanya ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
